/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// project imports
import { InvoiceList, InvoiceView, InvoiceEdit, InvoiceAllView, InvoiceRaView, InvoiceGDView } from 'features/components/base/invoice';
import InvoiceCreate from 'features/components/base/invoice/InvoiceCreate';

/**
 * routing for invoice components
 * 
 * @param props
 * 
 * @return routing for invoice components
 * 
**/

export class InvoiceRouter extends Component {

    render() {
        return (
            <Switch>
                <Route exact path={`/invoice`} component={ InvoiceList } />
                <Route exact path={`/invoice/view/:invoiceId`} component={ InvoiceView } />
                <Route exact path={`/invoice/ra/view/:invoiceId`} component={ InvoiceRaView } />
                <Route exact path={`/invoice/dg/view/:invoiceId`} component= { InvoiceGDView } />
                <Route exact path={`/invoice/edit/:invoiceId`} component={ InvoiceCreate } />
                <Route exact path={`/invoice/create`} component={ InvoiceCreate } />
                <Route exact path={`/invoice/viewall/`} component={ InvoiceAllView }/>

                <Redirect to="/home" />
            </Switch>
        );
    }
}